import { DateTime, } from "luxon";
import { isISOTimeString as isISOTimeStringShared, type ISOTimeString, } from "@bracket/sharedTypes";



export declare type DateIdentifier = DateTime | Date | ISOTimeString;


export const isDateIdentifier = ( value: unknown ): value is DateIdentifier => {
	return value instanceof DateTime || value instanceof Date || isISOTimeStringShared(value);
}

export const toDateTime = ( value: DateIdentifier ): DateTime => {
	const result = value instanceof DateTime ? value : value instanceof Date ? DateTime.fromJSDate(value) : isISOTimeStringShared(value) ? DateTime.fromISO(value) : null;
	if(result instanceof DateTime) return result;
	throw new Error("@bracket/types/toDateTime: Invalid date identifier provided, should be a DateTime, Date, or ISO 8601 date string");
}
